import { RouteType } from "types/RouteType";
import workflowsDashboardRoute from "./Dashboard/WorkflowsDashboard.Route";
import projectInitializationWizardRoute from "./ProjectInitialization/ProjectInitializationWizard.Route";
import dailyProductionLogWizardRoute from "./DailyProductionLog/DailyProductionLogWizard.Route";
import qcInspectionWizardRoute from "./QCInspection/QCInspectionWizard.Route";
import yardInventoryWizardRoute from "./YardInventory/YardInventoryWizard.Route";
import shipmentPlanningWizardRoute from "./ShipmentPlanning/ShipmentPlanningWizard.Route";
import engineeringDataWizardRoute from "./EngineeringData/EngineeringDataWizard.Route";
import productionScheduleWizardRoute from "./ProductionSchedule/ProductionScheduleWizard.Route";
import ncrWizardRoute from "./NCR/NCRWizard.Route";

// New workflow routes - Updated to use correct implementations
import projectBidProposalWizardRoute from "./Estimating/ProjectBidProposal/ProjectBidProposalWizard.Route";
import submittalPackageWizardRoute from "./Engineering/SubmittalPackage/SubmittalPackageWizard.Route";
import rfiManagementWizardRoute from "./Engineering/RFIManagement/RFIManagementWizard.Route";
import inventoryAdjustmentsWizardRoute from "./InventoryAdjustments/InventoryAdjustmentsWizard.Route";
import addRawMaterialsWizardRoute from "./AddRawMaterials/AddRawMaterialsWizard.Route";
import poRequisitionWizardRoute from "./PORequisition/PORequisitionWizard.Route";
import laborTimeTrackingWizardRoute from "./LaborTimeTracking/LaborTimeTrackingWizard.Route";
import equipmentMaintenanceWizardRoute from "./EquipmentMaintenance/EquipmentMaintenanceWizard.Route";
import toolCalibrationWizardRoute from "./QualityControl/ToolCalibration/ToolCalibrationWizard.Route";
import pieceRemediationWizardRoute from "./YardManagement/PieceRemediation/PieceRemediationWizard.Route";
import loadStagingWizardRoute from "./YardManagement/LoadStaging/LoadStagingWizard.Route";
import yardAuditWizardRoute from "./YardManagement/YardAudit/YardAuditWizard.Route";
import fleetDriverManagementWizardRoute from "./FleetDriverManagement/FleetDriverManagementWizard.Route";
import deliveryConfirmationWizardRoute from "./Dispatch/DeliveryConfirmation/DeliveryConfirmationWizard.Route";
import installationTrackingWizardRoute from "./InstallationTracking/InstallationTrackingWizard.Route";
import fieldIssueWizardRoute from "./FieldOperations/FieldIssue/FieldIssueWizard.Route";
import warrantyClaimWizardRoute from "./WarrantyClaim/WarrantyClaimWizard.Route";
import safetyComplianceWizardRoute from "./FieldOperations/SafetyCompliance/SafetyComplianceWizard.Route";
import changeOrderWizardRoute from "./ChangeOrder/ChangeOrderWizard.Route";
import projectBillingWizardRoute from "./ProjectBilling/ProjectBillingWizard.Route";
import customerCommunicationWizardRoute from "./ProjectManagement/CustomerCommunication/CustomerCommunicationWizard.Route";
import reportBuilderWizardRoute from "./Analytics/ReportBuilder/ReportBuilderWizard.Route";

const workflowsRoutesList: RouteType[] = [
  // Dashboard
  workflowsDashboardRoute,
  // // Existing workflows
  // projectInitializationWizardRoute,
  // dailyProductionLogWizardRoute,
  // qcInspectionWizardRoute,
  // yardInventoryWizardRoute,
  // shipmentPlanningWizardRoute,
  // engineeringDataWizardRoute,
  // productionScheduleWizardRoute,
  // ncrWizardRoute,
  // // New workflows
  // // Estimating
  // projectBidProposalWizardRoute,
  // // Engineering
  // submittalPackageWizardRoute,
  // rfiManagementWizardRoute,
  // // Materials
  // inventoryAdjustmentsWizardRoute,
  // addRawMaterialsWizardRoute,
  // poRequisitionWizardRoute,
  // // Maintenance
  // laborTimeTrackingWizardRoute,
  // equipmentMaintenanceWizardRoute,
  // // Quality Control
  // toolCalibrationWizardRoute,
  // // Yard Management
  // pieceRemediationWizardRoute,
  // loadStagingWizardRoute,
  // yardAuditWizardRoute,
  // // Dispatch
  // fleetDriverManagementWizardRoute,
  // deliveryConfirmationWizardRoute,
  // // Field Operations
  // installationTrackingWizardRoute,
  // fieldIssueWizardRoute,
  // warrantyClaimWizardRoute,
  // safetyComplianceWizardRoute,
  // // Project Management
  // changeOrderWizardRoute,
  // projectBillingWizardRoute,
  // customerCommunicationWizardRoute,
  // // Analytics
  // reportBuilderWizardRoute,
];

export default workflowsRoutesList;
